import client from '../client';
import endpoints from '../endpoints';

/* ── 서비스 (유저용) ── */

/** GET /api/notifications */
export const getNotifications = async (params = {}) => {
  const res = await client.get(endpoints.notifications.list, { params });
  return res.data;
};

/** PUT /api/notifications/:id/read */
export const markNotificationRead = async (id) => {
  const res = await client.put(endpoints.notifications.read(id));
  return res.data;
};

/* ── 관리자 ── */

/** GET /api/admin/notifications */
export const getAdminNotifications = async (params = {}) => {
  const res = await client.get(endpoints.admin.notifications.list, { params });
  return res.data;
};

/** POST /api/admin/notifications/send */
export const sendAdminNotification = async (data) => {
  const res = await client.post(endpoints.admin.notifications.send, data);
  return res.data;
};
